export default __webpack_public_path__ + "static/ingprev2-021bca1401fb965143e4591d64388cc9.mp4";